import { render } from "./MiniPlayer.vue?vue&type=template&id=b3120026&scoped=true"
import script from "./MiniPlayer.vue?vue&type=script&lang=js"
export * from "./MiniPlayer.vue?vue&type=script&lang=js"

import "./MiniPlayer.vue?vue&type=style&index=0&id=b3120026&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3120026"]])

export default __exports__